import { render, staticRenderFns } from "./leuco-introduce.vue?vue&type=template&id=66abcd83&"
import script from "./leuco-introduce.vue?vue&type=script&lang=js&"
export * from "./leuco-introduce.vue?vue&type=script&lang=js&"
import style0 from "./leuco-introduce.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports